import hexToRgba from "hex-to-rgba";

require("./lib/utils-color.css");

/**
 * Util function for return a html text color (black or white) which is
 * contrasting to the backgroun color hext passed.
 * Based on: https://gist.github.com/dcondrey/183971f17808e9277572
 *
 * @param {String} hex - The hex code of the background color to be contrast against
 * @returns {String} - Either 'black' or 'white'
 * @function
 */
export const contrastingTextToBackgroundColor = ({ hex, dark = "black", light = "white" }) => { // eslint-disable-line
  const rgb = hexToRgba(hex);
  const parens = rgb.match(/\(([^)]+)\)/)[0];
  const [r, g, b, a] = parens // eslint-disable-line
    .substr(1, parens.length - 2)
    .split(",")
    .map(str => str.trim())
    .map(str => parseInt(str, 10));

  // calculate contrast of color (standard grayscale algorithmic formula)
  const contrast =
    (Math.round(r * 299) + Math.round(g * 587) + Math.round(b * 114)) / 1000;

  return contrast >= 128 ? dark : light;
};
